export default __webpack_public_path__ + "static/media/pizzas-4.2989b48d.jpg";